import React from 'react';

import { AlertCircle } from '@lyearn/icons';

export const getDuplicateFileErrorIcon = () => {
  return <AlertCircle className="h-20 w-20" fillColorToken="icon-placeholder" />;
};
